import React from "react";

export const GridBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      {/* Grid */}
      <div className="absolute inset-0 bg-grid bg-grid-mask" />
      {/* Scan lines */}
      <div className="absolute inset-0 scan-lines opacity-60" />
      {/* Accent radial wash */}
      <div
        className="absolute -top-40 left-1/2 h-[480px] w-[860px] -translate-x-1/2 rounded-full blur-[120px] opacity-[0.10]"
        style={{ background: "radial-gradient(closest-side, #00E5FF, transparent 70%)" }}
      />
      {/* Bottom vignette */}
      <div className="absolute inset-x-0 bottom-0 h-72 bg-gradient-to-t from-[#0a0e14] to-transparent" />
    </div>
  );
};

export default GridBackground;
